import { Navigate } from 'react-router-dom';
import Admin from './pages/Admin';
import Home from './pages/Home';
import Logs from './pages/Logs';
import { ComplexRoute } from '../../components/Routes/Routes';

export default [
  {
    path: 'home',
    element: Home,
    label: 'Home',
  },
  {
    path: 'logs',
    element: Logs,
    label: 'Logs',
  },
  {
    path: 'admin',
    element: Admin,
    label: 'Admin',
  },
  {
    path: '/',
    element: <Navigate to="home" />,
  },
  {
    path: '*',
    element: <Navigate to="home" />,
  },
] as Array<ComplexRoute>;
